export const LANDING_PAGE_ID = "LOGGED_IN";
export const LANDING_PAGE_URL = "https://websim.com/";
